import styled from "styled-components";
import { getSite } from "../utils/sites";

const VideoEmbed = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => `0 ${theme.space[2]} 0`};
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin: ${({ theme }) => `4rem ${theme.space[2]} 0`};
  }
`;

const Video = () => {
  const site = getSite();
  const srcUrl =
    site === "main_ar"
      ? "https://www.youtube.com/embed/_PYutkaFhs4?si=sQSOhLVm6_niUZ59"
      : "https://www.youtube.com/embed/GG1qKSLSk88?si=BPJlUOzmcFp5wrDt";

  return (
    <VideoEmbed>
      <iframe
        width="560"
        height="315"
        src={srcUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </VideoEmbed>
  );
};

export default Video;
